import { render, staticRenderFns } from "./PatientFaceSheetViewRep.vue?vue&type=template&id=5bf1c42c&"
import script from "./PatientFaceSheetViewRep.vue?vue&type=script&lang=js&"
export * from "./PatientFaceSheetViewRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientFaceSheetViewRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports